import logoIcon from '../assets/logo192.png';
import logoIconLarge from '../assets/logo512.png';
import logoWordmark from '../assets/logo-with-name.png';
import logoMark from '../assets/logo.png';

/** Square app icon (192×192) — header, PWA, apple-touch-icon */
export const LOGO_ICON = logoIcon;

/** Full wordmark with “NMhelper” text — login screen */
export const LOGO_WORDMARK = logoWordmark;

/** Large square mark (512×512) — manifest / store */
export const LOGO_ICON_LARGE = logoIconLarge;

/** Full-resolution mark without wordmark */
export const LOGO_MARK = logoMark;

/** Public GitHub profile for credits / links */
export const GITHUB_PROFILE_URL = 'https://github.com/nishal21';
export const GITHUB_USERNAME = 'nishal21';
